
export const arrayReorder = <T>(array: Array<T>, ft: {from: number, to: number}): Array<T> => {
    const item = array[ft.from];
    array.splice(ft.from, 1);
    array.splice(ft.to, 0, item);
    return array;
};



// WEBPACK FOOTER //
// ./src/core/util/array-reorder.ts